import { ApolloError } from '@apollo/client/core'

export default class TokenExpiredError extends ApolloError {
  constructor() {
    super({ errorMessage: 'TOKEN_EXPIRED' })
  }
}
